import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";
import { tr } from "@/lib/i18n";
import { mpTrack } from "@/lib/metaPixel";

export default function AuthCallback() {
  const location = useLocation();
  const navigate = useNavigate();
  const { setUser, refreshAccess, lang } = useAuth();
  const hasProcessed = useRef(false);
  const t = (k) => tr(k, lang);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;
    const hash = location.hash || window.location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    if (!match) { navigate("/login", { replace: true }); return; }
    const session_id = decodeURIComponent(match[1]);
    (async () => {
      try {
        // Pass browser-detected lang so a first-time Google user lands
        // in the correct language on their first paint after signup.
        const r = await api.post("/auth/google/session", { session_id, lang });
        localStorage.setItem("leo_token", r.data.token);
        setUser(r.data.user);
        await refreshAccess();
        // Meta Pixel: only fire CompleteRegistration when the backend confirms
        // this Google sign-in created a brand new account (not on returning logins).
        if (r.data.is_new_user) {
          mpTrack("CompleteRegistration", { content_name: "google" });
        }
        window.history.replaceState(null, "", "/dashboard");
        navigate("/enter", { replace: true, state: { user: r.data.user } });
      } catch (e) {
        toast.error(t("toast.google_fail"));
        navigate("/login", { replace: true });
      }
    })();
    // eslint-disable-next-line
  }, []);

  return (
    <div className="min-h-[60vh] flex items-center justify-center">
      <div className="mono text-stone-400 text-sm tracking-widest">{t("loading.callback")}</div>
    </div>
  );
}
